import React from 'react';

import PropTypes from 'prop-types';

import { Text } from 'apps/auth/components/common/Text/Text';

const ActivityTitle = ({ message, color = 'primary' }) => {
    return (
        <Text variant="div" indent="4px" color={color}>
            {message}
        </Text>
    );
};
ActivityTitle.propTypes = {
    message: PropTypes.string,
    color: PropTypes.string,
};
export default ActivityTitle;
